var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"com-generador"},[_c('h2',[_vm._v("Añadir/editar empleado")]),_c('Empleado',{attrs:{"editable":true,"empleado":_vm.currentEmpleado}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }